import React from 'react';
import { Box, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';
import CityFilter from './CityFilter';
import { isSpaceSearchPath } from '../utils/searchPaths';

const Branding: React.FC = () => {
  const location = useLocation();
  const showCityFilter = isSpaceSearchPath(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Logo />
      {showCityFilter && (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ display: { xs: 'none', sm: 'flex' } }}>
          <CityFilter />
        </Stack>
      )}
    </Box>
  );
};

export default Branding;
